import { render, staticRenderFns } from "./FiltersBarInLive.vue?vue&type=template&id=271e54b8"
import script from "./FiltersBarInLive.vue?vue&type=script&lang=js"
export * from "./FiltersBarInLive.vue?vue&type=script&lang=js"
import style0 from "./FiltersBarInLive.vue?vue&type=style&index=0&id=271e54b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports